/**
 * Gestor del membrete para PDFs
 */
class MembreteManager {
    constructor() {
        this.membreteCache = null;
        this.membreteCacheOrientation = null;
        this.membreteUrls = [
            '/images/membreteQuro.png',
            './images/membreteQuro.png',
            `${process.env.PUBLIC_URL}/images/membreteQuro.png`,
            '/public/images/membreteQuro.png',
        ];
        this.membreteLandscapeUrls = [
            '/images/membreteQuroLandscape.png',
            './images/membreteQuroLandscape.png',
            `${process.env.PUBLIC_URL}/images/membreteQuroLandscape.png`,
            '/public/images/membreteQuroLandscape.png',
        ];
    }

    async loadMembreteImage(isPortrait = true) {

        // Usar cache si ya está cargado
        if (this.membreteCache && this.membreteCacheOrientation && this.membreteCacheOrientation === isPortrait) {
            console.log('✅ Usando membrete desde cache');
            return this.membreteCache;
        }

        try {

            const membreteLinkUrls = isPortrait ? this.membreteUrls : this.membreteLandscapeUrls;

            for (const url of membreteLinkUrls) {
                try {
                    const base64 = await this.convertImageToBase64(url);
                    if (base64) {
                        console.log(`✅ Membrete cargado desde: ${url}`);

                        // Guardar en cache
                        this.membreteCache = base64;
                        this.membreteCacheOrientation = isPortrait;
                        return base64;
                    }
                } catch (error) {
                    console.warn(`⚠️ Error cargando desde ${url}:`, error.message);
                    continue;
                }
            }

            //console.warn('⚠️ No se pudo cargar el membrete desde ninguna ruta');
            return null;

        } catch (error) {
            console.warn('⚠️ Error general cargando membrete:', error);
            return null;
        }
    }


    async convertImageToBase64(imageUrl) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';

            img.onload = function () {
                try {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    canvas.width = img.naturalWidth;
                    canvas.height = img.naturalHeight;

                    ctx.drawImage(img, 0, 0);

                    const base64 = canvas.toDataURL('image/png');
                    resolve(base64);
                } catch (error) {
                    reject(error);
                }
            };

            img.onerror = function (error) {
                reject(new Error(`Error cargando imagen: ${imageUrl}`));
            };

            // Construcción mejorada de URL
            let finalUrl;
            if (imageUrl.startsWith('/')) {
                finalUrl = window.location.origin + imageUrl;
            } else if (imageUrl.startsWith('./')) {
                finalUrl = window.location.origin + '/' + imageUrl.substring(2);
            } else {
                finalUrl = imageUrl;
            }

            img.src = finalUrl;
            //console.log(`🔍 Cargando imagen desde URL final: ${finalUrl}`);
        });
    }

    addMembreteAsBackground(pdf, membreteBase64) {
        if (!membreteBase64) {
            console.warn('⚠️ No hay membrete para agregar como fondo');
            return false;
        }

        try {
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            //console.log(`🖼️ Agregando membrete como fondo completo: ${pageWidth}x${pageHeight}mm`);

            pdf.addImage(
                membreteBase64,     // Imagen en base64
                'PNG',              // Formato
                0,                  // X = 0 (esquina izquierda)
                0,                  // Y = 0 (esquina superior)
                pageWidth,          // Ancho = ancho completo de la página
                pageHeight,         // Alto = alto completo de la página
                undefined,          // Alias (no necesario)
                'FAST'              // Compresión para mejor rendimiento como fondo
            );

            //console.log('✅ Membrete agregado correctamente como fondo de página');
            return true;

        } catch (error) {
            console.error('❌ Error agregando membrete como fondo:', error);
            return false;
        }
    }

    async addMembreteToNewPage(pdf, membreteBase64) {
        if (membreteBase64) {
            try {
                this.addMembreteAsBackground(pdf, membreteBase64);
                //console.log('✅ Fondo del membrete agregado a nueva página');
                return 50; // Posición Y ajustada
            } catch (error) {
                console.warn('⚠️ Error agregando fondo del membrete a nueva página:', error);
            }
        }
        return 20; // Posición Y normal sin membrete
    }

    clearCache() {
        this.membreteCache = null;
        this.membreteCacheOrientation = null;
        console.log('🗑️ Cache de membrete limpiado');
    }
}

export default MembreteManager;